import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';

export const OPCIONES_STATUS_PAGO = [
    { value: 0, label: 'No pagada' },
    { value: 1, label: 'Parcial' },
    { value: 2, label: 'Pagada' }
];

export default function FiltrosVentasModal({
    show,
    onCancel,
    onBuscar,
    metodos,
    folio,
    setFolio,
    metodo,
    setMetodo,
    fechaInicio,
    setFechaInicio,
    fechaFin,
    setFechaFin,
    statusPago,
    setStatusPago,
    mostrarStatusPago = true
}) {
    const opcionesMetodos = (Array.isArray(metodos) ? metodos : []).map((m) => ({
        value: m?._id || '',
        label: m?.nombre || ''
    })).filter((o) => !!o.value);

    return (
        <Modal show={!!show} onHide={onCancel} centered>
            <Modal.Header closeButton>
                <Modal.Title>Filtros avanzados</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="mb-3">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Folio"
                        value={folio || ''}
                        onChange={(e) => setFolio(e.target.value)}
                    />
                </div>

                <div className="mb-3">
                    <Select
                        value={metodo}
                        onChange={(opt) => setMetodo(opt || null)}
                        options={opcionesMetodos}
                        placeholder="Método"
                        isClearable
                    />
                </div>

                {mostrarStatusPago && (
                    <div className="mb-3">
                        <Select
                            value={statusPago}
                            onChange={(opts) => setStatusPago(opts || [])}
                            options={OPCIONES_STATUS_PAGO}
                            placeholder="Status de pago"
                            isMulti
                        />
                    </div>
                )}

                <div className="row">
                    <div className="col-6 mb-3">
                        <DatePicker
                            selected={fechaInicio}
                            onChange={(d) => setFechaInicio(d)}
                            className="form-control"
                            placeholderText="Fecha inicio"
                            dateFormat="dd/MM/yyyy"
                            isClearable
                        />
                    </div>
                    <div className="col-6 mb-3">
                        <DatePicker
                            selected={fechaFin}
                            onChange={(d) => setFechaFin(d)}
                            className="form-control"
                            placeholderText="Fecha fin"
                            dateFormat="dd/MM/yyyy"
                            isClearable
                        />
                    </div>
                </div>

                <div className="d-flex justify-content-end gap-2">
                    <button type="button" className="btn btn-secondary" onClick={onCancel}>
                        Cancelar
                    </button>
                    <button type="button" className="btn btn-primary" onClick={onBuscar}>
                        Buscar
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
}